import { RightGrantsEnum } from './@types/enum/rightGrantsEnum';

export const QUERY_DATA_STALE_TIME = 30 * 60 * 1000;

export const SNACKBAR_WIDTH = 400;

/* Default rights (Pages accessible to all users) */
export const DEFAULT_RIGHTS = ['/employeeInfo'];

export const RIGHT_TYPE_OPTIONS : Array<{ label : string; value : number }> = [
    { label: 'General', value: 0 },
    { label: 'Rights', value: 1 },
    { label: 'MasterData', value: 2 },
    { label: 'Transaction', value: 3 },
];

export const RIGHT_LEVELS : Record<string, number> = {
    'View': RightGrantsEnum.View,
    'Add': RightGrantsEnum.Add,
    'Edit': RightGrantsEnum.Edit,
    'Delete': RightGrantsEnum.Delete,
    'Admin': RightGrantsEnum.Admin,
};

export const RIGHT_GRANT_LEVEL_OPTIONS : Array<{ label : string; value : number }> = [
    { label: 'View', value: RightGrantsEnum.View },
    { label: 'Add', value: RightGrantsEnum.Add },
    { label: 'Edit', value: RightGrantsEnum.Edit },
    { label: 'Delete', value: RightGrantsEnum.Delete },
    { label: 'Admin', value: RightGrantsEnum.Admin },
];

// DD/MM/YYYY
export const DATE_FORMAT_DEFAULT_NO_SECONDS = 'DD/MM/YYYY HH:mm';
export const DATE_FORMAT_DEFAULT = 'DD/MM/YYYY HH:mm:ss';
export const DATE_FORMAT_DEFAULT_NO_TIME = 'DD/MM/YYYY';
export const DATE_FORMAT_SUMMARY = 'DD-MM-YYYY';

// DD/MM/YYYY
export const YEAR_FIRST_DATE_FORMAT_DEFAULT_NO_SECONDS = 'YYYY/MM/DD HH:mm';
export const YEAR_FIRST_DATE_FORMAT_DEFAULT = 'YYYY/MM/DD HH:mm:ss';
export const YEAR_FIRST_DATE_FORMAT_DEFAULT_NO_TIME = 'YYYY/MM/DD';
export const YEAR_FIRST_DATE_FORMAT_SUMMARY = 'YYYY-MM-DD';


// YYYY/MM/YYYY
export const DATE_FORMAT_NO_SECONDS = 'YYYYMMDD HH:mm';
export const DATE_FORMAT_DATETIME_FROM_API = 'YYYY-MM-DDTHH:mm:ss';